import { defineStore } from '/src/core/store';

export const useNfcStore = defineStore('nfc', {
	state: () => ({
		supported: undefined,
		enabled: undefined,
		continuous: false,
	}),
	persist: {
		storage: 'native',
		pick: ['continuous'],
		migrate: 'local',
	},
	actions: {
		setSupported (supported) {
			this.supported = supported;
		},
		setEnabled (enabled) {
			this.enabled = enabled;
		},
		setContinuous (continuous) {
			this.continuous = continuous;
		},
	},
});
